import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * WebCADの表示設定ダイアログ
 * グリッド色、背景色など
 */
export default class CustomizeDisplayDialog extends Dialog {
  gridColor: string;// グリッド色に使用

  backgroundColor: string;// 背景色に使用

  // 結合gridUnitの表示/非表示のフラグ
  public _showMergeUnitGridFlag: boolean = false;

  // ブラウザのローカルストレージに使用
  public _storage: any;

  // デフォルトのグリッド色
  public defaultGridColor: string;

  // デフォルトの背景色
  public defaultBackgroundColor: string;

  // パフォーマンスの表示/非表示のフラグ
  public _showPerformanceFlag: boolean = false;

  /**
   * コンストラクタ
  */
  constructor(draggable: boolean) {
    super(draggable);
    this._storage = localStorage;
    // defaultGridColorおよびdefaultBackgroundColorの値を設定します
    this.defaultGridColor = '#A09E9E';
    this.defaultBackgroundColor = '#ffffff';
    /* -----gridColorとbackgroundColorの値を割り当てる start here----*/
    // ブラウザのlocalStorage値のチェック条件が存在するかどうか。
    if (localStorage.getItem('gridColor') !== null) {
      // localStorageをgridColorに割り当てます
      this.gridColor = localStorage.getItem('gridColor');
    } else {
      // gridColorにデフォルト値を割り当てます
      this.gridColor = document.getElementById('Layer0_0_FILL_gridLinev').children[0].getAttribute('stroke');
    }
    if (localStorage.getItem('backgroundColor') !== null) {
      // localStorageをbackgroundColorに割り当てます
      this.backgroundColor = localStorage.getItem('backgroundColor');
    } else {
      // backgroundColorにデフォルト値を割り当てます
      this.backgroundColor = document.getElementById('layerGroup').querySelector('#grid').querySelector('rect').getAttribute('fill');
    }
    /* -----gridColorとbackgroundColorの値を割り当てる end here----*/
    // ダイアログのコンテンツ生成
    const id = 'customizeDisplayDialog';
    // タイトル
    let title = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Settings'; break;
      default: title = '設定'; break;
    }
    let contents = '<div class="customizeDisplayDialog customizeDisplayDialog_contentBox">\n';
    contents += '<div class="subttl"><span class="jp">表⽰カスタマイズ</span><span class="en">Customize Display</span></div>';
    contents += '<div class="checkMerge_div"><input id="checkMergeUnitGrid" type="checkbox" checked="checked"/> <span id="checkMergeUnitGrid_label"><span class="jp">5グリッド単位でグリッド線を太くする</span><span class="en">5 Make grid lines thicker in grid units</span></span></div>\n';
    contents += '<table>\n';
    contents += '<tbody>\n';
    contents += '<tr>\n';
    contents += '<th><span class="jp">グリッド色：</span><span class="en">Grid Color:</span></th>\n';
    contents += '<td><input type="color" id="colorPickerGrid" /></td>\n';
    contents += '</tr>\n';
    contents += '<tr>\n';
    contents += '<th><span class="jp">背景色：</span><span class="en">Background Color:</span></th>\n';
    contents += '<td><input type="color" id="colorPickerBackground" /></td>\n';
    contents += '</tr>\n';
    contents += '<tr>\n';
    contents += '<td class="restore_td" colspan="2"><button id="restoreDefault"><span class="jp">初期設定に戻す</span><span class="en">Restore Default</span></button></td>\n';
    contents += '</tr>\n';
    contents += '</tbody>\n';
    contents += '</table>\n';
    contents += '</div>';
    contents += '<div class="p-webcadControlDescriptionBox customizeDisplayDialog_contentBox">';
    contents += '<div class="subttl"><span class="jp">パフォーマンス分析</span><span class="en">Performance Analyse</span></div>';
    contents += '<div class="helpPerformanceNotShowDiv" id="helpPerformanceNotShowDiv"><input type="checkbox" name="helpCheckPerformanceDisplay" id="helpCheckPerformanceDisplay"><label class="jp" id="helpCheckPerformanceDisplayLabel">起動時にパフォーマンスチェックを行わない</label><label class="en" id="helpCheckPerformanceDisplayLabel">Do not perform performance check at startup</label></div>';
    contents += '</div>';
    let footer = '<button id="btnDoneCustomizeDisplay"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    this.createDialog(id, title, contents, footer);

    if (!marietta.webcad.WebCADGlobal.performanceCheckDisplay) {
      document.getElementById('helpCheckPerformanceDisplay').setAttribute('disabled', 'disabled');
      document.getElementById('helpPerformanceNotShowDiv').querySelectorAll('label').forEach((element) => {
        element.classList.add('disabled');
      });
    } else {
      document.getElementById('helpCheckPerformanceDisplay').removeAttribute('disabled');
      document.getElementById('helpPerformanceNotShowDiv').querySelectorAll('label').forEach((element) => {
        element.classList.remove('disabled');
      });
    }
    if (marietta.webcad.WebCADGlobal.userAgentManager.isIE) {
      document.getElementById('helpPerformanceNotShowDiv').style.display = 'none';
    }
    if (localStorage.getItem('notShowPerformance') === '1') {
      (<HTMLInputElement>document.getElementById('helpCheckPerformanceDisplay')).checked = true;
      this._showPerformanceFlag = true;
    } else {
      (<HTMLInputElement>document.getElementById('helpCheckPerformanceDisplay')).checked = false;
      this._showPerformanceFlag = false;
    }
    const triggerPerformanceCheckboxClick = document.querySelector('#helpCheckPerformanceDisplayLabel');
    triggerPerformanceCheckboxClick.addEventListener('click', this.triggerPerformanceCheckboxClick);

    // ShowPerformanceチェックボックスのクリックハンドル
    const showPerformanceCheck = document.querySelector('#helpCheckPerformanceDisplay');
    showPerformanceCheck.addEventListener('click', this.showPerformanceCheckClicked);

    /* -----showMergeUnitGridFlagの値を割り当てる start here----*/
    // ブラウザのlocalStorage値のチェック条件が存在するかどうか
    // localStorageに基づいてMergeUnitGridチェックボックスのハンドルをチェック/チェック解除します
    if (localStorage.getItem('showMergeUnitGrid') === '1' || localStorage.getItem('showMergeUnitGrid') === null) {
      (<HTMLInputElement>document.getElementById('checkMergeUnitGrid')).checked = true;
      this._showMergeUnitGridFlag = true;
    } else {
      (<HTMLInputElement>document.getElementById('checkMergeUnitGrid')).checked = false;
      this._showMergeUnitGridFlag = false;
    }
    /* -----showMergeUnitGridFlagの値を割り当てる end here----*/

    // イベント設定
    // OKButtonクリックをトリガー
    const btn = document.querySelector('#btnDoneCustomizeDisplay');
    btn.addEventListener('click', this.btnEventHandler);

    // closeButtonクリックをトリガー
    document.getElementById('btnClose').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.removeDialog();
    });

    // MergeUnitGridチェックボックスクリックのトリガーshowMergeGridCheckBoxClicked関数
    const showCheck = document.querySelector('#checkMergeUnitGrid');
    showCheck.addEventListener('click', this.showMergeGridCheckBoxClicked);
    const triggerCheckboxClick = document.querySelector('#checkMergeUnitGrid_label');
    triggerCheckboxClick.addEventListener('click', this.triggerCheckboxClick);

    // ResetButtonクリックをトリガー
    const btn1 = document.querySelector('#restoreDefault');
    btn1.addEventListener('click', this.restoreBtnEventHandler);

    (<HTMLInputElement>document.getElementById('colorPickerGrid')).value = this.gridColor;
    (<HTMLInputElement>document.getElementById('colorPickerBackground')).value = this.backgroundColor;
    (<HTMLInputElement>document.getElementById('colorPickerGrid')).addEventListener('change', (e) => {
      this.gridColor = (<HTMLInputElement>e.target).value;
    }, false);
    (<HTMLInputElement>document.getElementById('colorPickerBackground')).addEventListener('change', (e) => {
      this.backgroundColor = (<HTMLInputElement>e.target).value;
    }, false);
  }

  /**
   * MergeUnitGridチェックボックスクリックの処理
   * チェック/チェック解除に基づいてshowMergeUnitGridFlagを設定します
   * @return void
   * @param e => mouse event
  */
  showMergeGridCheckBoxClicked = () => {
    const notShow = (<HTMLInputElement>document.querySelector('#checkMergeUnitGrid')).checked;
    if (notShow) {
      this._showMergeUnitGridFlag = true;
    } else {
      this._showMergeUnitGridFlag = false;
    }
  }

  /**
   * ラベルクリックでトリガーチェックボックスクリック
   * @return void
   * @param e => mouse event
  */
  triggerCheckboxClick = () => {
    document.getElementById('checkMergeUnitGrid').click();
  }

  /**
   * OKボタンがクリックされた
   * グリッド色、背景色、squareUnitマージグリッドを処理します
   * @return void
   * @param e => mouse event
  */
  btnEventHandler = (e: any) => {
    e.preventDefault();
    // ブラウザのlocalStorageにgridColorとbackgroundColorを設定します
    this._storage.setItem('gridColor', this.gridColor);
    this._storage.setItem('backgroundColor', this.backgroundColor);

    // MergeGridUnitの表示/非表示を処理します
    if (this._showMergeUnitGridFlag) {
      // ブラウザのlocalStorageにMergeUnitGridを設定します
      this._storage.setItem('showMergeUnitGrid', '1');
      // MergeGridUnitを表示
      // Gridlayer.showMergeGridUnit関数をトリガー
      marietta.webcad.WebCADGlobal.layerGroup.grid.showMergeGridUnit();
      // marietta.webcad.WebCADGlobal.layerGroup.grid.createSquareMerge(marietta.webcad.WebCADGlobal.mergeSquareUnit);
    } else {
      // ブラウザのlocalStorageにMergeUnitGridを設定します
      this._storage.setItem('showMergeUnitGrid', '0');
      // MergeGridUnitを非表示
      // Gridlayer.hideMergeGridUnit関数をトリガー
      marietta.webcad.WebCADGlobal.layerGroup.grid.hideMergeGridUnit();
      // marietta.webcad.WebCADGlobal.layerGroup.grid.createLines();
    }
    // gridColorとbackgroundColorの変更
    // Gridlayer.changeColor関数をトリガー
    marietta.webcad.WebCADGlobal.layerGroup.grid.changeColor(this.gridColor, this.backgroundColor);

    // performanceLoaderの表示/非表示の処理
    if (this._showPerformanceFlag) {
      // ブラウザのlocalStorageでshowPerformanceを設定します
      this._storage.setItem('notShowPerformance', '1');
    } else {
      // ブラウザのlocalStorageでshowPerformanceを設定します
      this._storage.setItem('notShowPerformance', '0');
    }

    // パネルを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();
  }

  /**
  * グリッドの色と背景色をデフォルトに戻す
  * @return void
  * @param e => mouse event
  */
  restoreBtnEventHandler = (e: any) => {
    e.preventDefault();
    this.gridColor = this.defaultGridColor;
    this.backgroundColor = this.defaultBackgroundColor;
    (<HTMLInputElement>document.getElementById('colorPickerGrid')).value = this.gridColor;
    (<HTMLInputElement>document.getElementById('colorPickerBackground')).value = this.backgroundColor;

    // チェックボックスをデフォルトに設定
    (<HTMLInputElement>document.getElementById('checkMergeUnitGrid')).checked = true;
    this._showMergeUnitGridFlag = true;
  }

  /**
   * ラベルクリックでトリガーチェックボックスクリック
   * @return void
   * @param e => mouse event
  */
  triggerPerformanceCheckboxClick = () => {
    document.getElementById('helpCheckPerformanceDisplay').click();
  }

  /**
   * PerformanceCheckチェックボックスクリックの処理
   * チェック/チェック解除に基づいてPerformanceCheckFlagを設定します
   * @return void
   * @param e => mouse event
  */
  showPerformanceCheckClicked = () => {
    const notShow = (<HTMLInputElement>document.getElementById('helpCheckPerformanceDisplay')).checked;
    if (notShow) {
      this._showPerformanceFlag = true;
    } else {
      this._showPerformanceFlag = false;
    }
  }
}
